import Breadcrumbs from "components/breadcrumbs";
import ParentOrganismRooms from "components/parentOrganismRooms";
import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";

const OrganismClasses = () => {

    const auth = useSelector((state: RootStateOrAny) => state.auth);
    const { user } = useSelector((state) => state.auth);

    return (
        <React.Fragment>
            <Breadcrumbs isClassroom={true} isBack={false} />
            <ParentOrganismRooms />
        </React.Fragment>
    );

}

export default OrganismClasses;